<template lang="html">
  <div>
    <p class="heading is-size-7 has-text-dark-orange pr-1">{{ title }}</p>
    <b-tooltip v-if="tooltip" type="is-dark" :label="tooltip">
      <b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: ['title', 'tooltip'],
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
